import { Button, Space } from "antd";
import { ReactNode } from "react";
import { Link, useParams } from "react-router-dom";
import LeaveInfoIcon from "../../../assets/icons/LeaveInfoIcon";
import RightArrow from "../../../assets/icons/RightArrow";
import useModal from "../../../hooks/useModal";
import { GetLeaveBalanceDetailsResponseType } from "../../../types";
import InfoTitle from "../../common/InfoTitle";
import AdjustmentLogModal from "./AdjustmentLogModal";

export default function LeaveInfo({
  data,
}: {
  data?: GetLeaveBalanceDetailsResponseType["data"]["leave_info"];
}) {
  const { viewId } = useParams();
  const { open, handleOpen, handleClose } = useModal<number>();

  return (
    <div className="md:col-span-5 bg-white rounded-md border border-extra-light p-6">
      <AdjustmentLogModal
        open={open?.open}
        data={open?.data}
        handleClose={handleClose}
      />

      <InfoTitle className="mb-6" icon={<LeaveInfoIcon />}>
        Leave Info
      </InfoTitle>

      <div className="max-h-[300px] overflow-y-auto">
        {data?.leave_balances?.map((item) => (
          <LeaveInfoItem
            key={item?.leave_type_id}
            title={item?.leave_type}
            childrenClass="!justify-self-start w-full"
            days={
              <div className="flex justify-center">
                {`${item?.remaining_days} / ${item?.total_days} Days`}
                {/* {item?.is_leave_adjusted ? (
                  <span className="ml-2.5 text-extra-gray">(Adjusted)</span>
                ) : null} */}
              </div>
            }
          >
            <div className="flex justify-between items-center w-full">
              {item?.is_leave_adjusted ? (
                <>
                  {/* <Button
                  className="action-button"
                  size="small"
                  icon={<ViewIcon />}
                /> */}
                  <button
                    className="-ml-2.5 text-accent font-medium"
                    onClick={() =>
                      handleOpen({
                        data: item?.leave_type_id,
                      })
                    }
                  >
                    (Adjusted)
                  </button>
                </>
              ) : (
                <div />
              )}
              <Space align="center" size={8}>
                <span className="h-8 px-2 text-sm font-medium text-status-danger-text bg-status-danger-bg rounded-md justify-center items-center inline-flex">
                  Prorated
                </span>
                <Link
                  to={`/admin/settings/leave/leave-prorate/${viewId}/${item?.business_member_leave_type_id}`}
                >
                  <Button
                    className="middle-button !border-none !text-accent"
                    size="small"
                    icon={<RightArrow />}
                  />
                </Link>
              </Space>
            </div>
          </LeaveInfoItem>
        ))}
        {/* <LeaveInfoItem title="Sick Leave" days="0 / 14 Days">
          <Space align="center" size={8}>
            <span className="h-8 px-2 text-sm font-medium text-status-danger-text bg-status-danger-bg rounded-md justify-center items-center inline-flex">
              Prorated
            </span>
            <Button
              className="middle-button !border-none !text-accent"
              size="small"
              icon={<RightArrow />}
            />
          </Space>
        </LeaveInfoItem> */}
        <LeaveInfoItem
          title="Leave Approved"
          days={
            <Space className="flex justify-center" size={12}>
              <span className="w-3 h-3 bg-complete rounded-full inline-block" />
              {data?.leave_approved_count || 0} Request
            </Space>
          }
        />
        <LeaveInfoItem
          title="Leave Rejected"
          days={
            <Space className="flex justify-center" size={12}>
              <span className="w-3 h-3 bg-highlight rounded-full inline-block" />
              {data?.leave_rejected_count || 0} Request
            </Space>
          }
        />
      </div>
    </div>
  );
}

interface LeaveInfoItemProps {
  title: string;
  days: ReactNode;
  childrenClass?: string;
  children?: ReactNode;
}

const LeaveInfoItem = ({
  title,
  days,
  children,
  childrenClass,
}: LeaveInfoItemProps) => (
  <div className="w-full grid grid-cols-3 items-center py-2 first:pt-0 last:pb-0 border-b border-extra-light last:border-none">
    <h6 className="text-extra-gray text-base font-medium">{title}</h6>
    <span className="text-display-body font-medium min-w-[100px]">{days}</span>
    <div className={`justify-self-end min-h-8 ${childrenClass}`}>
      {children}
    </div>
  </div>
);
